import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React__default, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import img$1 from '../../images/logo-header-base.svg.js';
import img from '../../images/logo-header-pro.svg.js';
import { backgroundMain } from '../../theme/theme-style.js';
import { t } from '../../utils/utils.js';
import Button from '../buttons/button.component.js';
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var Container = styled.div.withConfig({
  displayName: "auth-headercomponent__Container",
  componentId: "sc-19ai04w-0"
})(["width:100%;background-color:", ";"], backgroundMain);
var Row = styled.div.withConfig({
  displayName: "auth-headercomponent__Row",
  componentId: "sc-19ai04w-1"
})(["display:flex;max-width:calc(100% - 48px);width:1140px;height:72px;margin-left:auto;margin-right:auto;flex-direction:row;align-items:center;justify-content:space-between;@media screen and (max-width:768px){height:56px;}"]);
var Logo = styled.img.withConfig({
  displayName: "auth-headercomponent__Logo",
  componentId: "sc-19ai04w-2"
})(["height:30px;object-fit:contain;display:flex;min-width:172px;"]);
var header_map = {
  pro: {
    logo: img,
    logo2: img,
    title: "header.pro",
    link: "/"
  },
  base: {
    logo: img$1,
    logo2: img$1,
    title: "header.base",
    link: "https://youngplatform.com"
  }
};
var btn_map = {
  login: {
    text: "header.login",
    link: "/login"
  },
  signup: {
    text: "header.signup",
    link: "/signup"
  }
};
var AuthHeader = /*#__PURE__*/function (_Component) {
  _inherits(AuthHeader, _Component);
  var _super = _createSuper(AuthHeader);
  function AuthHeader() {
    var _this;
    _classCallCheck(this, AuthHeader);
    _this = _super.call(this);
    _this.state = {
      loaded: false
    };
    return _this;
  }
  _createClass(AuthHeader, [{
    key: "render",
    value: function render() {
      var _header_map$product$l;
      var _this$props = this.props,
        LinkComponent = _this$props.LinkComponent,
        product = _this$props.product,
        lng = _this$props.lng,
        isMobile = _this$props.isMobile,
        isFromSite = _this$props.isFromSite,
        btnKey = _this$props.btnKey;
      var loaded = btnKey != null;
      if (loaded && this.state.loaded == false) {
        this.setState({
          loaded: true
        });
      }
      return /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Row, {
        isMobile: isMobile
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, !header_map[product].link || !((_header_map$product$l = header_map[product].link) !== null && _header_map$product$l !== void 0 && _header_map$product$l.includes("https")) ? /*#__PURE__*/React__default.createElement(LinkComponent, {
        style: {
          textDecoration: "none",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        to: header_map[product].link
      }, /*#__PURE__*/React__default.createElement(Logo, {
        alt: "young platform",
        src: header_map[product].logo
      })) : /*#__PURE__*/React__default.createElement("a", {
        style: {
          textDecoration: "none",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        href: header_map[product].link
      }, /*#__PURE__*/React__default.createElement(Logo, {
        alt: "young platform",
        src: header_map[product].logo
      }))), loaded && btnKey ? /*#__PURE__*/React__default.createElement(Button, {
        fontFamily: "graphik",
        type: "primary",
        color: "green",
        active: "true",
        text: t(lng, btn_map[btnKey].text),
        borderRadiusType: isFromSite ? "rounded" : "smallRounded",
        LinkComponent: LinkComponent,
        link: btn_map[btnKey].link,
        style: {
          marginLeft: "auto"
        },
        heightButton: isMobile ? "small" : "medium"
      }) : null));
    }
  }]);
  return AuthHeader;
}(Component);
var authHeader_component = withTheme(AuthHeader);
export { authHeader_component as default };